import {
  fetchLeague,
  fetchLeaguePurchases,
  restartLeagueDraft,
  updateLeague,
} from '../../entities/league';

export const scope = 'LEAGUE_SUPPORT';

export function fetchLeagueIfNeeded(leagueId) {
  return (dispatch, getState) => {
    const {league} = getState().app.support;

    if (!league.info.isFetching) dispatch(fetchLeague(leagueId, scope));
  };
}

export function fetchPurchases(payload, onSuccess, onError) {
  return dispatch => {
    dispatch(fetchLeaguePurchases(payload, scope, onSuccess, onError));
  };
}

export function restartDraft(payload, onSuccess, onError) {
  return dispatch => {
    dispatch(restartLeagueDraft(payload, scope, onSuccess, onError));
  };
}

export function leagueUpdate(payload, leagueId, onSuccess, onError) {
  return dispatch => {
    dispatch(updateLeague(payload, leagueId, onSuccess, onError));
  };
}



// WEBPACK FOOTER //
// ./src/actions/app/support/league.js